<template>
  <div>
    <el-table
        class="appTable"
        :data="dataSource"
        v-bind="$attrs"
        v-on="$listeners"
        :size="tableSize"
        ref="appTable"
        :max-height="maxHeight"
        :border="true"
        :header-cell-style="{ color: '#504F54' }"
        :row-class-name="tableRowClassName"
        :editRowId="editRowId"
        :row-key="rowKey"
        @row-click="rowClick"
    >
      <el-table-column
          v-if="firstColumn"
          align="center"
          type="index"
          label="序号"
          width="50"
      >
      </el-table-column>
      <template v-if="expandedColumns">
        <el-table-column type="expand">
          <template slot-scope="props">
            <el-form label-position="left" inline class="demo-table-expand">
              <template v-for="(column, index) of expandedColumns">
                <el-form-item v-bind="column" :key="index">
                  <!-- render -->
                  <extend
                      v-if="column.render"
                      :render="column.render"
                      :params="props"
                  ></extend>
                  <!-- no render -->
                  <span v-else>{{ props.row[column.prop] }}</span>
                </el-form-item>
              </template>
            </el-form>
          </template>
        </el-table-column>
      </template>
      <template v-for="(column, index) of columns">
        <!-- render -->
        <el-table-column
            v-if="column.render"
            v-bind="Object.assign({}, defaultColumnConfig, column)"
            :key="index"
        >
          <template slot-scope="scope">
            <extend :render="column.render" :params="scope"></extend>
          </template>
        </el-table-column>
        <!-- no render -->
        <el-table-column
            v-else
            v-bind="Object.assign({}, defaultColumnConfig, column)"
            :key="index"
        ></el-table-column>
      </template>
    </el-table>
  </div>
</template>

<script>
import extend from "./extend.js";

export default {
  name: "AppTable",
  components: {extend},
  props: {
    rowKey: {
      default: "id",
    },
    dataSource: {
      type: Array,
    },
    columns: {
      type: Array,
    },
    firstColumn: {
      type: Boolean,
      default: false,
    },
    expandedColumns: {
      type: Array,
    },
    tableSize: {
      type: String,
      default: "medium",
    },
    iconView: {
      type: Number,
      default: 3,
    },
    maxHeight: {
      type: Number,
      default: 550,
    },
    editRowId: {
      type: Number,
      default: null,
    },
    defaultColumnConfig: {
      type: Object,
      default() {
        return {
          align: "center",
        };
      },
    },
  },
  methods: {
    rowClick(row) {
      this.$emit("row-click", row)
    },
    tableRowClassName({row}) {
      if (row.id === this.editRowId || row.lessonId === this.editRowId) {
        return "warning-row";
      }
      return "";
    },
  },
};
</script>

<style lang="scss" scoped>
.appTable {
  ::v-deep .warning-row {
    background: #ea5513;
  }

  .demo-table-expand {
    font-size: 0;
    margin-left: 20px;
  }

  .demo-table-expand ::v-deep label {
    width: 90px;
    color: #99a9bf;
  }

  .demo-table-expand ::v-deep .el-form-item {
    margin-right: 0;
    margin-bottom: 0;
    width: 50%;
  }

  ::v-deep .el-table__row--level-1 .el-table__indent {
    padding-left: 50px !important;
  }

  ::v-deep .el-table__row--level-2 .el-table__indent {
    padding-left: 80px !important;
  }
}
</style>
